export interface YearRange {
  from: number
  to: number
}

/**
 * Collapses a set of years into ascending ranges. Duplicates and unsorted
 * input are tolerated. Never returns a flat list where a range exists.
 */
export function collapseYearRanges(years: readonly number[]): YearRange[] {
  const sorted = [...new Set(years)].sort((a, b) => a - b)
  const ranges: YearRange[] = []
  for (const year of sorted) {
    const last = ranges.at(-1)
    if (last && year === last.to + 1) {
      last.to = year
    } else {
      ranges.push({ from: year, to: year })
    }
  }
  return ranges
}

/** e.g. `1920–1979, 1981, 1983–1985` */
export function formatYearRanges(ranges: readonly YearRange[], separator = ', '): string {
  return ranges.map(formatYearRange).join(separator)
}

export function formatYearRange(range: YearRange): string {
  return range.from === range.to ? String(range.from) : `${range.from}–${range.to}`
}

/** Years present in `all` but not in `kept`, collapsed into ranges. */
export function excludedYearRanges(all: readonly number[], kept: readonly number[]): YearRange[] {
  const keptSet = new Set(kept)
  return collapseYearRanges(all.filter((year) => !keptSet.has(year)))
}
